module.exports = __webpack_public_path__ + "img/wit-sponsor-logo@2x.40c25fe4.png";